import styles from './project.module.css';
import IndPro from './IndPro'
import UrbanC from './UrbanC'
import StarWars from './StarWars'



const Project=()=>{ 
    return <div id="projects" className={styles.main}>
        <h1 className="text_theme">My <span className="text-blue">Project</span></h1>
        <UrbanC/><IndPro /><StarWars/>
    </div>
}

export default Project;